import { MsChevron as r } from "@sunrise/icons";
import { defineComponent as u, computed as m } from "vue";
const s = u({
  name: "CsSort",
  components: {
    MsChevron: r
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: String,
    options: {
      type: Array,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    function a(e) {
      const o = e.target;
      n("update:modelValue", o.value);
    }
    const l = m(() => {
      const e = t.options.find((o) => o.value === t.modelValue);
      return e ? e.label : "";
    });
    return {
      onChange: a,
      label: l
    };
  }
});
export {
  s as default
};
